class TimezoneService extends BaseService
	@register angular.module 'App.Service'
	@inject 'BACKEND_TIME_ZONES'

	getTimezones: ->
		timezones = []

		for timezone in @BACKEND_TIME_ZONES
			if !Intl.supportedValuesOf('timeZone').includes(timezone)
				continue

			region = timezone.split('/').shift()
			offset = @getTimezoneOffsetString(timezone)

			offsetNumbers = offset.match(/\w+([+-]\d{2}):(\d{2})/)

			timezones.push({
				region: region
				name: timezone
				offsetString: offset
				offset: (parseInt(offsetNumbers[1]) * 60) + parseInt(offsetNumbers[2])
				display: "(#{offset}) #{timezone}"
			})

		return timezones

	getTimezoneOffsetString: (timezone) ->
		value = Intl.DateTimeFormat(
				'ia',
				{
					timeZoneName: 'longOffset',
					timeZone: timezone,
				}
			)
			.formatToParts()
			.find((part) => part.type == 'timeZoneName')
			.value

		if value == 'GMT'
			value += '+00:00'

		# Replace Minus Sign with regular dash
		return value.replace(/\u2212/, '-')
